import React from "react";
import { Row, Col, Spin, Button, Modal, Icon, Popover, message } from "antd";
import dynamic from "next/dynamic";
import Router from "next/router";
import Notice from "./Notice";
import { OPENGAME_VENDOR_SEARCH_KEY, OPENGAME_NAME_SEARCH_KEY, INBOXMSG_TYPE_ID_ENUM } from "$ACTIONS/constantsData";
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { Cookie as CookieUtil, formatAmount } from "$ACTIONS/util";
import { GetAllBalance } from "$DATA/wallet";
import { getMemberInfo } from "$DATA/userinfo";
import { getQueryVariable, Cookie } from "$ACTIONS/helper";
import { piwikNavBar } from "$ACTIONS/OneWallet202501PiwikUtil";
import { genAutoIframe, rewardUrlToAutoLogoutUrl } from "@/base";
import { connect, Provider } from "react-redux";
import { balanceActions } from "../../store/balanceSlice";
import { DEFAULT_PARAMS, enumWalletProductGroupId, isToggleOn, MAIN_BALANCE_TEXT } from "$ACTIONS/balanceRequest";
import { setBalanceV2Action, setBalanceWalletGroupAction } from "../../store/thunk/balanceThunk";
import { setBonusProgressAction } from "../../store/thunk/bonusThunk";
import { promotionActions } from "../../store/promotionSlice";
import { userCenterActions } from "../../store/userCenterSlice";
import store from "../../store/store";
import classNames from "classnames";
import Newbie, { CSS_CLASSNAME, CSS_CLASSNAME2, IMG_BALANCE_DETAIL_NEWBIE } from "@/UI/Newbie"
import LockedBalanceTrait from "$ACTIONS/trait/OneWallet/LockedBalanceTrait";
// import OtpPopUp from '@/OTP/OtpPopUp';
import { handleDepositClick , handleWithdrawalClick } from "../CentralPayment/CentralPaymentModal/CentralPaymentUtils";
import Mdl2025 from "@/UI/Mdl2025";
import ResetPwd from '@/ResetPwd/';

const genAutoLogoutRewardIframe = src => genAutoIframe('autoLogoutSkyKingRewardIfr', src)

// Modal加载状态组件
const ModalLoading = (
    <Spin spinning={true} size="large" tip="加载中，请稍后..." />
);
// 财务管理
const DynamicWallet = dynamic(import("@/Wallet"), {
    loading: () => ModalLoading,
    ssr: true,
});
// 安全系统升级
const DynamicOtpPopUp = dynamic(import("@/OTP/OtpPopUp"), {
    ssr: false,
});

const SHOW_SIMPLE_HOVER_TYPE1 = 1;
const SHOW_SIMPLE_HOVER_TYPE2 = 2;
class HasLogged extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oneWalletBalanceHoverSelectedId: undefined,
            isHideBalanceDtlNewbie: true,
            showType: -1, // -1 初始化 0.1 隐藏个人中心 0.2 隐藏余额 1 个人中心简介 2 余额
            showTypePosition: { x: 122, y: 166 },
            isModalLoad: true,
            modalTabKey: {}, // showDailog的公用属性对象
            balanceLoading: false, // might be deprecated
            walletVisible: false,
            balanceList: [],
            memberInfo: {},
            userName: "", // 会员名称
            helloString: "", // 问候时间段
            token: "",
            messageIsRead: false, // 是否有未读消息
            logoutType: "", // 8号商城登出问题
            otpVisible: false, // otp 驗證匡
            kindOfVerification: "", //是otp验证还是otp+密码验证
            isLoadOtpModal: false,
            countBalance: 0,
			isAmbassadorPage: false,
            precheckInfoModal: false,
            precheckPhoneModal: false,
        };

        this.LockedBalanceTrait = LockedBalanceTrait(this);
        this.LockedBalanceTrait.init();
        this.otpModal = this.otpModal.bind(this); // otp modal
        this.showModal = this.showModal.bind(this); // showModal公用方法
        this.hideWalletModal = this.hideWalletModal.bind(this); // hideWalletModal公用方法
        this.getBalance = this.getBalance.bind(this); // 获取余额
        this.showSimple = this.showSimple.bind(this); // 显示个人或者余额下拉
        this.hideSimple = this.hideSimple.bind(this); // 隐藏个人或者余额下拉
        this.closeWallet = this.closeWallet.bind(this); // 关闭钱包弹层
        this.getHelloTime = this.getHelloTime.bind(this); // 获取问候语时间段
        this.globalExit = this.globalExit.bind(this); // 退出方法
        this.globalBlackListExit = this.globalBlackListExit.bind(this);
        this.setGlobalMemberInfo = this.setGlobalMemberInfo.bind(this);
        this.setHasUnRead = this.setHasUnRead.bind(this); // 设置（Header弹窗、UserCenter）是否有未读消息
        this.checkHasReadMessage = this.checkHasReadMessage.bind(this); // 判断是否有未读消息
        this.currentModalKey = ""; // 当前显示的ModalKey
        this.delayTimer = null; // 个人或者余额下拉延迟关闭timer（防止过度闪动，高频率打开关闭！）
        this.messageIntervalTimer = null;
        this.controlExit = false; // 控制請求logout時,勿重複請求，如重複登入引起的強制登出
        global.globalExit = this.globalExit; // 全局化退出方法
        global.globalBlackListExit = this.globalBlackListExit; //黑名單專用退出
        global.setGlobalMemberInfo = this.setGlobalMemberInfo; // 全局更新会员信息（HasLogged&&UserCenter内部的memberInfo）
    }
		hideWalletModal() {
			this.setState({
				walletVisible: false
			})
		}
    componentDidMount() {
		const pathname = window.location.pathname;
        const isAmbassadorPage = pathname.indexOf("ambassador") !== -1;
        this.setState({ isAmbassadorPage });
        if (getQueryVariable("redirectToken")) return;

        this.getHelloTime();

        this.props.dispatchSetBalanceV2Action();
        this.props.dispatchSetBalanceWalletGroupAction();
        this.getBalance();

        global.showDialog = this.showModal;
				global.hideWalletModal = this.hideWalletModal;
        this.props.onHasLoggedEvent(this.showSimple, this.hideSimple);

        getMemberInfo((memberInfo) => {
            const memberdate = memberInfo || {};
            this.setState({ userName: memberdate.userName });

            if (
                !localStorage.getItem("login-otp") &&
                memberdate.isLoginOTP == true
            ) {
                //OTP流程
                this.setState({
                    isLoadOtpModal: true,
                    otpVisible: true,
                    kindOfVerification: "OTP",
                });
            }
            if (
                !JSON.parse(localStorage.getItem("login-otpPwd")) &&
                memberdate.revalidate
            ) {
                //OTP流程 + 重置密码流程
                this.setState({
                    isLoadOtpModal: true,
                    otpVisible: true,
                    kindOfVerification: "revalidate",
                });
            }

            this.setGlobalMemberInfo(memberInfo);
        }, true);

        // 传递设置已读未读状态的方法出去、另外还需要传递设置usercenter左侧的小圆点的方法进来
        this.props.setCircleHasUnRead &&
            this.props.setCircleHasUnRead((status) => {
                this.props.setMessageHasUnRead(status);
                this.setState({ messageIsRead: status });
            });

        // 判断是否有未读消息
        this.checkHasReadMessage();
        this.messageIntervalTimer = setInterval(
            this.checkHasReadMessage,
            360000
        );

        // 默认呼出组件（开发需要）
        // this.showModal({ key: 'wallet:{"type": "deposit", "currentPayValue": "CTC"}' })
        // key: 'wallet:{"type": "deposit", "currentPayValue": "LB", "targetAccount": "SB", "bonusId": 103502}'
        this.checkIsSafeHouse();
    }
    componentWillUnmount() {
        global.showDialog = function () {};
        clearTimeout(this.delayTimer);
        clearInterval(this.messageIntervalTimer);
    }

    setGlobalMemberInfo(res) {
        this.setState({ memberInfo: res });
        console.log("获取会员详情的数据-------------->", res);
        //登录OTP PASS 进行下面Ref流程
        !res.isLoginOTP && this.props.ReferreeTaskStatus();
        // 同步HasHeader MemberInfo 到子元素同时设置更新HasHeader MemberInfo的方法
        this.props.setUserCenterMemberInfo &&
            this.props.setUserCenterMemberInfo(
                res,
                (v) => {
                    this.setState({ memberInfo: v });
                },
                this.getBalance
            );
    }
    checkHasReadMessage() {
        get(
            ApiPort.Announcements +
                "&messageTypeOptionID=0&pageSize=1&pageIndex=1"
        ).then((res) => {
            if (res?.result?.totalUnreadCount) {
                this.setHasUnRead(true);
            } else {
                get(
                    ApiPort.InboxMessages +
                        "&messageTypeId=" + INBOXMSG_TYPE_ID_ENUM.TRANSACTION + "&messageTypeOptionIdList=0&pageSize=1&pageIndex=1"
                ).then((res) => {
                    if (res?.result?.totalUnreadCount) {
                        this.setHasUnRead(true);
                    } else {
                        get(
                            ApiPort.InboxMessages +
                                "&messageTypeId=" + INBOXMSG_TYPE_ID_ENUM.PERSONAL + "&messageTypeOptionIdList=0&pageSize=1&pageIndex=1"
                        ).then((res) => {
                            if (res?.result?.totalUnreadCount) {
                                this.setHasUnRead(true);
                            }
                        });
                    }
                });
            }
        });
    }
    setHasUnRead(status) {
        this.props.setUsercnnterCircle &&
            this.props.setUsercnnterCircle(status);
        this.props.setMessageHasUnRead(status);
        this.setState({ messageIsRead: status });
    }
    getHelloTime() {
        const hour = new Date().getHours();

        this.setState({
            helloString:
                hour < 6
                    ? "凌晨"
                    : hour < 9
                    ? "早上"
                    : hour < 12
                    ? "上午"
                    : hour < 14
                    ? "中午"
                    : hour < 19
                    ? "下午"
                    : hour < 24
                    ? "晚上"
                    : "",
        });
    }
    getBalance(call) {
        this.setState({ balanceLoading: true });
        GetAllBalance((res) => {
            this.setState({balanceLoading: false})
            if (res && res.isSuccess) {
                console.log("钱包列表------->", res);



                res.result.map(function (item, index) {
                    window[item.name] = item.balance;
                });
                const allBalance = res.result[0].balance;
                console.log("allBalance: ", allBalance);
                this.props.setUserCenterMoney &&
                    this.props.setUserCenterMoney({
                        balanceList: res.result,
                        mainMoney: allBalance,
                    });
                this.props.setUserAllBalance(allBalance);
                this.setState({
                    balanceList: res.result,
                    countBalance:
                        res.result && res.result.length
                            ? res.result[0].balance
                            : 0,
                });
                typeof call === "function" && call(allBalance);
            } else if (res && res.errors) {
                message.error(res.errors && res.errors[0].message);
            }
        }, undefined, {reqMoreConf:{viaInitialPageLoaded:true}});
    }
    // 关闭钱包弹层
    closeWallet(type) {
        this.setState({ walletVisible: false });
        if (type == "ToHome") {
            if (Router.router.pathname != "/cn") {
                Router.push("/cn");
            }
        }

        if (Router.router.pathname == "/cn/Games/OpenGame") {
            const isXxxGame = (vendor, name) => {
                let o = new URL(window.location.href)
                  , qsVendor = o.searchParams.get(OPENGAME_VENDOR_SEARCH_KEY)
                  , qsName = o.searchParams.get(OPENGAME_NAME_SEARCH_KEY)
                  ;
                return qsVendor && qsName && qsVendor.toLowerCase()==vendor.toLowerCase() && qsName==name;
            }
            if (isXxxGame('LiveCasino', 'DGG')) { // for IPT2-271
                // nop
            } else {
            Router.push("/cn");
            }
        }

        typeof global.openLearnDialog === "function" &&
            global.openLearnDialog();
    }
    // 呼出组件（所有弹出层窗口都可公用这个函数，需设置一级State和二级State，只需传入对应State即可！）
    showModal({ key }) {
        if (typeof key !== "string") return null;
        const keySpacer = key.indexOf(":");
        const dialogKey = key.substring(0, keySpacer);
        const keyMap = key.substring(keySpacer + 1);
        const currentParentModalMap =
            typeof keyMap !== "" ? JSON.parse(keyMap) : {}; // 当前呼出窗口携带的默认属性
        this.setState({
            [dialogKey + "Visible"]: true,
            modalTabKey: currentParentModalMap,
        });
    }
    showSimple(type, positionType) {
        // 因为游戏界面锁定了小Header，而此教程需要锁定大Header，因此会出现UI乱掉，需要关闭弹出此教程。
        // if (this.props.headerHeightLock !== 1) {
        //     const learnStepString = CookieUtil("learnStep");
        //     typeof learnStepString === "string" &&
        //         learnStepString.substr(2, 1) === "0" &&
        //         this.props.toggleHeaderCenterLearn(true);
        // }
        if (type==SHOW_SIMPLE_HOVER_TYPE2) {
            let $el = document.getElementsByClassName(CSS_CLASSNAME), showNewbieInsteadOfPopover;
            if (!$el.length) {
                $el = document.getElementsByClassName(CSS_CLASSNAME2)
            }
            if ($el.length) {
                for (let $el_ of $el) {
                    let $imgs = $el_.getElementsByTagName('img');
                    if (!$imgs.length || typeof $imgs[0].getAttribute!=='function') { continue }
                    let src = $imgs[0].getAttribute('src');
                    if (!src) { continue; }
                    if (src.includes(IMG_BALANCE_DETAIL_NEWBIE)) {
                        showNewbieInsteadOfPopover = true;
                        break;
                    }
                }
            }
            if (showNewbieInsteadOfPopover) {
                this.setState({ isHideBalanceDtlNewbie: false })
                return;
            }
        }

        clearTimeout(this.delayTimer);
        positionType === "top" &&
            this.setState({
                showTypePosition: { x: type === 1 ? 240 : 195, y: 54 },
            });
        positionType === "bottom" &&
            this.setState({
                showTypePosition: { x: type === 1 ? 52 : 20, y: 180 },
            });
        this.setState({ showType: type });
        this.props.onChangeShowType(type);
    }
    hideSimple(type) {
        if (this.state.showType === -1) {
            return;
        }
        this.delayTimer && clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
            this.setState({ showType: type });
            this.props.onChangeShowType(0);
        }, 200);
    }

    globalExit(snapExitStatus) {
        genAutoLogoutRewardIframe(rewardUrlToAutoLogoutUrl())

        const { memberInfo } = this.state;
        const access_token = JSON.parse(localStorage.getItem("access_token"));
        const refresh_token = JSON.parse(localStorage.getItem("refresh_token"));
        let data = {
            clientId: "FUNmuittenCN",
            clientSecret: "muitten",
            refreshToken: refresh_token,
            accessToken: access_token,
            memberCode: memberInfo.memberCode,
            packageName: "net.funpodium.tlc",
        };

        if (this.controlExit) return;
        const IsSnapExitStatus = typeof snapExitStatus === "undefined";

        // IsSnapExitStatus &&
        // 	post(ApiPort.LogoutAPI, data)
        // 		.then((res) => {
        // 			// 8shop导向登录退出立即就会登录，登录会更正客服链接，所以此处如果传递function不需要调用。
        // 			get(ApiPort.GETLiveChat).then((res) => {
        // 				localStorage.setItem('serverUrl', res.url);
        // 				setTimeout(() => {
        // 					this.controlExit = false;
        // 				}, 3000);
        // 			});
        // 		})
        // 		.catch((error) => {});

        this.controlExit = true;
        localStorage.getItem("access_token") !== null && this.props.LoginExit(); // 更正会员登录状态
        Modal.destroyAll(); // 清除所有弹出层
        CookieUtil(null, null);
        Cookie.Delete("emailTime"); //測試分支上無法刪除，再執行一次
        Cookie.Delete("phoneTime"); //測試分支上無法刪除，再執行一次
        // Member LocalData
        localStorage.removeItem("affiliateUrlLM");
        localStorage.removeItem("PreferWallet");
        localStorage.removeItem("UserName");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("memberInfo");
        localStorage.removeItem("memberInfo");
        localStorage.removeItem("walletList");
        localStorage.removeItem("Address");
        // Bti LocalData
        localStorage.removeItem("ReferURL");
        localStorage.removeItem("APIUrl");
        localStorage.removeItem("MemberToken");
        localStorage.removeItem("gameTypeBannerList");
        localStorage.removeItem("login-otp");
        localStorage.removeItem("login-otpPwd");
        sessionStorage.clear();

        this.props.resetPromotionData();
        this.props.resetMemberData();

        IsSnapExitStatus && message.success("您已退出登录！");

        // 因为多语言目录层级关系，配置了默认页面位/cn/index.js，此处为了应对开发时退出会刷新界面，使用强刷！
        // process.env.LANGUAGE_PREFIX ? Router.push('/cn/') : window.location.href = "/cn/";
        // 此处为了测试退出后的一些状态时是否及时更新预留
        IsSnapExitStatus && Router.push("/cn/");

        if (IsSnapExitStatus) {
            if (this.state.checkSafeHouse || Cookie.Get("isLoginS")) {
                window.location.href = "/cn/Safehouse";
                Cookie.Delete("isLoginS");
            } else {
                Cookie.Delete("isLoginS");
            }
        }
        if (!!localStorage.getItem("BankcardBlacklist")) {
            //银行卡黑名单
            const removeBankcardBlacklist = () => {
                localStorage.removeItem("BankcardBlacklist");
            };
            Modal.info({
                className: "confirm-modal-of-public",
                icon: <div />,
                title: "",
                width: 340,
                zIndex: "1600",
                centered: true,
                content: (
                    <div className="inline-link-btn">
                        <div>
                            <img
                                src={"/cn/img/maintain/img-restricted.png"}
                                style={{ width: "120px", height: "130px" }}
                            />
                        </div>
                        <h3
                            style={{
                                fontSize: "18px",
                                fontWeight: 900,
                                marginTop: "20px",
                            }}
                        >
                            用户账号违反本站规章
                        </h3>
                        <div style={{ textAlign: "center" }}>
                            抱歉 ， 由于您的账号违反本站规章，即日起已被关闭
                        </div>
                    </div>
                ),
                okText: (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src="/cn/img/icons/icon-cs.png"
                            style={{ marginRight: "10px" }}
                        />
                        在线客服
                    </div>
                ),
                onOk: () => {
                    global.PopUpLiveChat();
                    removeBankcardBlacklist();
                },
                onCancel: () => {
                    removeBankcardBlacklist();
                },
            });
        }
    }

    /*專門給黑名單使用的logout 不跳回首頁  */

    globalBlackListExit(snapExitStatus) {
        if (this.controlExit) return;
        const IsSnapExitStatus = typeof snapExitStatus === "undefined";

        this.controlExit = true;
        localStorage.getItem("access_token") !== null && this.props.LoginExit(); // 更正会员登录状态
        Modal.destroyAll(); // 清除所有弹出层
        CookieUtil(null, null);
        // Member LocalData
        localStorage.removeItem("affiliateUrlLM");
        localStorage.removeItem("PreferWallet");
        localStorage.removeItem("UserName");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("memberInfo");
        localStorage.removeItem("memberInfo");
        localStorage.removeItem("walletList");
        // Bti LocalData
        localStorage.removeItem("ReferURL");
        localStorage.removeItem("APIUrl");
        localStorage.removeItem("MemberToken");
        localStorage.removeItem("gameTypeBannerList");
        localStorage.removeItem("login-otp");
        localStorage.removeItem("login-otpPwd");
        sessionStorage.clear();

        IsSnapExitStatus && message.success("您已退出登录！");

        if (IsSnapExitStatus) {
            if (this.state.checkSafeHouse || Cookie.Get("isLoginS")) {
                window.location.href = "/cn/Safehouse";
                Cookie.Delete("isLoginS");
            } else {
                Cookie.Delete("isLoginS");
            }
        }
        if (!!localStorage.getItem("BankcardBlacklist")) {
            //银行卡黑名单
            const removeBankcardBlacklist = () => {
                localStorage.removeItem("BankcardBlacklist");
            };
            Modal.info({
                className: "confirm-modal-of-public",
                icon: <div />,
                title: "",
                width: 340,
                zIndex: "1600",
                centered: true,
                content: (
                    <div className="inline-link-btn">
                        <div>
                            <img
                                src={"/cn/img/maintain/img-restricted.png"}
                                style={{ width: "120px", height: "130px" }}
                            />
                        </div>
                        <h3
                            style={{
                                fontSize: "18px",
                                fontWeight: 900,
                                marginTop: "20px",
                            }}
                        >
                            用户账号违反本站规章
                        </h3>
                        <div style={{ textAlign: "center" }}>
                            抱歉 ， 由于您的账号违反本站规章，即日起已被关闭
                        </div>
                    </div>
                ),
                okText: (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src="/cn/img/icons/icon-cs.png"
                            style={{ marginRight: "10px" }}
                        />
                        在线客服
                    </div>
                ),
                onOk: () => {
                    global.PopUpLiveChat();
                    removeBankcardBlacklist();
                },
                onCancel: () => {
                    removeBankcardBlacklist();
                },
            });
        }
    }

    checkIsSafeHouse = () => {
        get(ApiPort.GETisSafeHouse)
            .then((res) => {
                console.log("isSafeHouse Domain res: ", res);
                if (res?.result?.isSafeHouse) {
                    this.setState({
                        checkSafeHouse: true,
                    });
                }
            })
            .catch((error) => {
                console.log("isSafeHouse Domain error: ", error);
            });
    };

    Exit() {
        Modal.confirm({
            icon: null,
            centered: true,
            title: "确认退出",
            content: "确认要退出登录吗？",
            // okButtonProps: {size: "large"},
            // cancelButtonProps: {size: "large"},
            okText: "退出",
            cancelText: "取消",
            onOk: () => {
                this.globalExit();
            },
        });
    }

    otpModal(v) {
        this.setState({ otpVisible: v });
    }

    checkSpecificPaths = () => {
        const path = window.location.pathname;
        return /\/cn\/(history|bankCard)\/?$/.test(path);
    }

    goToDeposit = () => {
        const { dispatch, useCentralPayment } = this.props;
        handleDepositClick(dispatch, useCentralPayment);
    }

    depositPreCheck = () => {
        console.log('12345')
        let memberInfo = JSON.parse(localStorage.getItem("memberInfo"));
        if (memberInfo) {
          let PhoneObj =
            memberInfo &&
            memberInfo.contacts &&
            memberInfo.contacts.length &&
            memberInfo.contacts.find((v) => v.contactType === "Phone");
          let EmailObj =
            memberInfo &&
            memberInfo.contacts &&
            memberInfo.contacts.length &&
            memberInfo.contacts.find((v) => v.contactType === "Email");
          // 老會員 byPassCheck == true 就不擋
          const registerDate = memberInfo && new Date(memberInfo.registerDate);
          const comparisonDate = new Date("2023-12-21T00:00:00");
          let byPassCheck =
            registerDate < comparisonDate || memberInfo.isDeposited == 1;
          if (
            !byPassCheck &&
            (!memberInfo.firstName ||
              !memberInfo.dob ||
              !memberInfo.identityCard ||
              !memberInfo.gender ||
              !EmailObj)
          ) {
            this.setState({ precheckInfoModal: true });
          } else if (!PhoneObj || PhoneObj.status !== "Verified") {
            this.setState({ precheckPhoneModal: true });
          } else {
                handleDepositClick(this.props.dispatch, this.props.useCentralPayment);
          }
        }
    };

    render() {
        // HasLogged组件因为是在渲染之后才会render出来，所以在内部可调用dom相关事件
        const { showType, memberInfo, balanceList, countBalance, isAmbassadorPage } = this.state;
        const isCentralPayment = this.checkSpecificPaths()
        let userPopover, walletPopover;
        console.log("memberInfo", memberInfo);
        switch (showType) {
            case -1:
                (userPopover = ""), (walletPopover = "");
                break;
            case 1:
                userPopover = "show";
                break;
            case 2:
                walletPopover = "show";
                break;
            case 0.1:
                userPopover = "hide";
                break;
            case 0.2:
                walletPopover = "hide";
                break;
            default:
                break;
        }

        const storeBalance = this.props.storeBalance;
        const storeBalanceV2Result = storeBalance.v2?.result || {};
        const storeBalanceUIIsLoading = storeBalance.UIIsLoading;
        const matchedSubBalance = this.state.oneWalletBalanceHoverSelectedId!=enumWalletProductGroupId.MAIN.ID && storeBalanceV2Result.balances?.find(_=>_.walletProductGroupId==this.state.oneWalletBalanceHoverSelectedId);

        const storeBonus = this.props.storeBonus;
        const storeBonusProgressResult = storeBonus.Progress?.result;
        const storeBonusUIIsLoading = storeBonus.UIIsLoading;

        const isSpinLoading = storeBalanceUIIsLoading||storeBonusUIIsLoading;

        const _levelName =
            this.state.memberInfo?.memberNewInfo
            &&
            Object.prototype.hasOwnProperty.call(this.state.memberInfo.memberNewInfo, 'levelName')
            ? this.state.memberInfo.memberNewInfo.levelName
            : this.state.memberInfo.levelName;

        return (
            <React.Fragment>
                {!isCentralPayment && (
                                    <div className="common-distance-wrap">
                                    <div
                                        className={`common-distance tlc-sign-header ${
                                            this.props.smallHeader === "zoom-out" && "hidden"
                                        }${
                                            this.props.toggleCenterPopover
                                                ? " user-center-popover"
                                                : ""
                                        }`}
                                    >
                                        <Row>
                                            <Col span={12} className="tlc-notice-wrapper">
                                                <Notice propsData={this.props} />
                                            </Col>
                                            <Col span={12} className="tlc-sign">
                                                <div className="login-wrap">
                                                    <div className="good-greeting"  style={{color: isAmbassadorPage ? "white" : "initial"}}>
                                                        {this.state.helloString}好，
                                                        {this.state.userName ||
                                                            memberInfo.userName}
                                                    </div>
                                                    <div className="Right-Login-Action">
                                                        <div className="input-wrap">
                                                            <div
                                                                className={`user-center-btn${
                                                                    showType === 1
                                                                        ? " active"
                                                                        : ""
                                                                }`}
                                                                onMouseEnter={() =>
                                                                    this.showSimple(1, "bottom")
                                                                }
                                                                onMouseLeave={() =>
                                                                    this.hideSimple(0.1)
                                                                }
                                                                onClick={() => {
                                                                    Pushgtagdata(
                                                                        "Profile_homepage"
                                                                    );
                                                                }}
                                                            >
                                                                <span>个人中心</span>
                                                                <i
                                                                    className={`tlc-sprite user-message ${
                                                                        this.state.messageIsRead
                                                                            ? "remind-circle"
                                                                            : ""
                                                                    }`}
                                                                />
                                                                <Icon type="caret-down" />
                                                            </div>
                                                            <div
                                                                className={`wallet-center-btn${
                                                                    showType === 2
                                                                        ? " active"
                                                                        : ""
                                                                }`}
                                                                onMouseEnter={() =>
                                                                    this.showSimple(2, "bottom")
                                                                }
                                                                onMouseLeave={() =>
                                                                    this.hideSimple(0.2)
                                                                }
                                                                onClick={() => {
                                                                    Pushgtagdata(
                                                                        "Accountwallet_homepage"
                                                                    );
                                                                }}
                                                            >
                                                                <span>￥</span>
                                                                <span>
                                                                    {formatAmount(storeBalanceV2Result.totalBalance, true)}
                                                                </span>
                                                                <Icon type="caret-down" />
                                                            </div>
                                                        </div>
                                                        <div className="BtnList">
                                                            <div
                                                                className="deposit-btn btnYellow "
                                                                onClick={() => {
                                                                    if(this.props.useCentralPayment){
                                                                        this.depositPreCheck()
                                                                    }else{
                                                                        this.showModal({
                                                                            key: 'wallet:{"type": "deposit"}',
                                                                        });
                                                                    }
                                                                    Pushgtagdata(
                                                                        "Deposit Nav",
                                                                        "Click",
                                                                        "Deposit_TopNav"
                                                                    );
                                                                }}
                                                            >
                                                                存款
                                                            </div>
                                                            <div
                                                                className="withdraw-btn btnPurple "
                                                                onClick={() => {
                                                                    if(this.props.useCentralPayment){
                                                                        handleWithdrawalClick(this.props.dispatch , this.props.useCentralPayment)
                                                                    }else{
                                                                        this.showModal({
                                                                            key: 'wallet:{"type": "withdraw"}',
                                                                        });
                                                                    }
                                                                    Pushgtagdata(
                                                                        "Withdrawal Nav",
                                                                        "Click",
                                                                        "Withdrawal_TopNav"
                                                                    );
                                                                }}
                                                            >
                                                                提款
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                )}
                {/* Header头部弹窗 */}
                <div
                    className={`common-distance-wrap header-popover-wrap${
                        this.props.headerHeightLock === "has-login"
                            ? " show-hard"
                            : ""
                    }${
                        this.props.toggleCenterPopover
                            ? " has-header-center"
                            : ""
                    }`}
                >
                    <div className="common-distance">
                        <div
                            style={{
                                right: this.state.showTypePosition.x,
                                top: this.state.showTypePosition.y,
                            }}
                            className={`header-popover ${
                                this.props.headerHeightLock === "has-login" ||
                                this.props.toggleCenterPopover
                                    ? "show"
                                    : userPopover
                            }`}
                            onMouseEnter={() => this.showSimple(1)}
                            onMouseLeave={() => this.hideSimple(0.1)}
                        >
                            <div className="header-popover-content">
                                <div className="header-popover-arrow" />
                                <div className="header-popover-inner">
                                    <div className="header-popover-inner-title user-title-wrap">
                                        <div className="inline-block">
                                            <div className="user-picture-wrap">
                                                <img src="/cn/img/home/icon/userAvatar.svg" />
                                            </div>
                                        </div>
                                        <div
                                            className="inline-block"
                                            style={{
                                                transform: "translateY(-11px)",
                                            }}
                                        >
                                            <h4>
                                                {" "}
                                                {this.state.userName ||
                                                    memberInfo.userName}
                                            </h4>
                                            <div className="user-info-thumb">
                                                <div className="inline-block">
                                                    <i
                                                        className={`tlc-sprite member-grade _${
                                                            _levelName !==
                                                            "普通会员"
                                                                ? "1"
                                                                : "2"
                                                        }`}
                                                    />
                                                    <span>
                                                        {
                                                            _levelName
                                                        }
                                                    </span>
                                                </div>
                                                <span className="inline-block">
                                                    &nbsp;
                                                </span>
                                                <div className="inline-block">
                                                    <i
                                                        className={`tlc-sprite user-email ${
                                                            this.state
                                                                .memberInfo
                                                                .isVerifiedEmail &&
                                                            this.state
                                                                .memberInfo
                                                                .isVerifiedEmail[1] &&
                                                            "curr"
                                                        }`}
                                                    />
                                                    <i
                                                        className={`tlc-sprite user-phone ${
                                                            this.state
                                                                .memberInfo
                                                                .isVerifiedPhone &&
                                                            this.state
                                                                .memberInfo
                                                                .isVerifiedPhone[1] &&
                                                            "curr"
                                                        }`}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <Button
                                            ghost
                                            className="user-exit"
                                            onClick={() => {
                                                //  this.Exit();
                                                this.globalExit();
                                                Pushgtagdata(
                                                    "Logout_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            退出
                                        </Button>
                                    </div>
                                {this.props.useCentralPayment ? (
                                    <div className="header-popover-inner-content headerHoverBox">
                                    <div
                                        className="userinfo"
                                        onClick={() => {
                                            this.props.goUserCenter(
                                                "userinfo"
                                            );
                                            Pushgtagdata(
                                                "Account",
                                                "Click",
                                                "Profile_TopNav"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite user-info" />
                                        账户资料
                                    </div>
                                    <div
                                        className={`message${
                                            this.state.messageIsRead
                                                ? " remind-circle"
                                                : ""
                                        }`}
                                        onClick={() => {
                                            this.props.goUserCenter(
                                                "message"
                                            );
                                            Pushgtagdata(
                                                "PMA_accountbar_homepage"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite message-center" />
                                        通知中心
                                    </div>
                                      <div
                                        className={`message${
                                            this.state.messageIsRead
                                                ? " remind-circle"
                                                : ""
                                        }`}
                                        onClick={() => {
                                            this.props.goUserCenter(
                                                "uploadFiles"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite message-center" />
                                        上传文件
                                    </div>
                                    <div
                                        className={`message${
                                            this.state.messageIsRead
                                                ? " remind-circle"
                                                : ""
                                        }`}
                                        onClick={() => {
                                            this.props.goUserCenter(
                                                "securitycheck"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite message-center" />
                                        安全检查
                                    </div>
                                    <div
                                        className={`message${
                                            this.state.messageIsRead
                                                ? " remind-circle"
                                                : ""
                                        }`}
                                        onClick={() => {
                                            this.props.goUserCenter(
                                                "createsecuritycode"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite message-center" />
                                        创建安全码
                                    </div>
                                    <div
                                        className="mypromotion"
                                        onClick={() => {
                                            this.props.changeTab("2");
                                            Router.push("/cn/Promotions");
                                            Pushgtagdata(
                                                "Promorecord_accountbar_homepage"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite my-promotion" />
                                        我的优惠
                                    </div>
                                    <div
                                        className="mybonus"
                                        onClick={() => {
                                            this.props.changeTab("3");
                                            Router.push("/cn/Promotions");
                                            Pushgtagdata(
                                                "Rebaterecord_accountbar_homepage"
                                            );
                                        }}
                                    >
                                        <i className="tlc-sprite my-bonus" />
                                        我的返水
                                    </div>
                                </div>
                                    ):(
                                        <ul className="header-popover-inner-content headerHoverBox">
                                        <li
                                            className="userinfo"
                                            onClick={() => {
                                                this.props.goUserCenter(
                                                    "userinfo"
                                                );
                                                Pushgtagdata(
                                                    "Account",
                                                    "Click",
                                                    "Profile_TopNav"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite user-info" />
                                            账户资料
                                        </li>
                                        {/* <li
											className="vipTab"
											onClick={() => {
												this.props.goUserCenter('vip');
											}}
										>
											<i className="tlc-sprite vip-icons" />VIP
										</li> */}
                                        <li
                                            className={`message${
                                                this.state.messageIsRead
                                                    ? " remind-circle"
                                                    : ""
                                            }`}
                                            onClick={() => {
                                                this.props.goUserCenter(
                                                    "message"
                                                );
                                                Pushgtagdata(
                                                    "PMA_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite message-center" />
                                            通知中心
                                        </li>
                                        <li
                                            className="records"
                                            onClick={() => {
                                                this.props.goUserCenter(
                                                    "records"
                                                );
                                                Pushgtagdata(
                                                    "Transactionrecord_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite record" />
                                            交易记录
                                        </li>
                                        <li
                                            className="bankaccount"
                                            onClick={() => {
                                                this.props.goUserCenter(
                                                    "bankaccount"
                                                );
                                                Pushgtagdata(
                                                    "Bankacc_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite bank-user"/>
                                            银行信息
                                        </li>
                                        <li
                                            className="mypromotion"
                                            onClick={() => {
                                                this.props.changeTab("2");
                                                Router.push("/cn/Promotions");
                                                Pushgtagdata(
                                                    "Promorecord_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite my-promotion" />
                                            我的优惠
                                        </li>
                                        <li
                                            className="betrecords"
                                            onClick={() => {
                                                this.props.goUserCenter(
                                                    "betrecords"
                                                );
                                                Pushgtagdata(
                                                    "Account",
                                                    "Click",
                                                    "BetRecord_TopNav"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite bet-record" />
                                            投注记录
                                        </li>
                                        {/* <li className="ptaccount" onClick={() => {
											this.props.goUserCenter('ptaccount');
											Pushgtagdata("PTacc_accountbar_homepage");
										}}>
											<i className="tlc-sprite pt-account" />PT 账户
										</li> */}
                                        <li
                                            className="mybonus"
                                            onClick={() => {
                                                this.props.changeTab("3");
                                                Router.push("/cn/Promotions");
                                                Pushgtagdata(
                                                    "Rebaterecord_accountbar_homepage"
                                                );
                                            }}
                                        >
                                            <i className="tlc-sprite my-bonus" />
                                            我的返水
                                        </li>
                                        {this.props.smarticoVisible && (
                                            <li
                                                className="mybonus"
                                                onClick={() => {
                                                    Pushgtagdata(
                                                        "Home",
                                                        "Go to RewardsCentre",
                                                        "Home_C_RewardsCentre"
                                                    );
                                                    if (localStorage.getItem("access_token") == null) {
                                                        global.goUserSign("1");
                                                        return;
                                                    }
                                                    this.props.changeTab("3");
                                                    Router.push('/cn/rewards-centre');
                                                    // Pushgtagdata(
                                                    //     "Rebaterecord_accountbar_homepage"
                                                    // );
                                                }}
                                            >
                                                <i className="tlc-sprite smartico"/>
                                                彩金殿堂
                                            </li>
                                        )}
                                        {/* <li
											className="changerecords"
											onClick={() => {
												this.props.goUserCenter('changerecords');
												Pushgtagdata('Redeemrecord_accountbar_homepage');
											}}
										>
											<i className="tlc-sprite change-record" />兑换记录
										</li> */}
                                    </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div
                            id="one-wallet-popover"
                            style={{
                                right: this.state.showTypePosition.x,
                                top: this.state.showTypePosition.y,
                            }}
                            className={`header-popover wallet ${walletPopover}`}
                            onMouseEnter={() => this.showSimple(2)}
                            onMouseLeave={() => this.hideSimple(0.2)}
                        >
                            <div className="header-popover-content">
                                <div
                                    className={`header-popover-arrow${
                                        isSpinLoading
                                            ? " loading"
                                            : ""
                                    }`}
                                />
                                <div className="header-popover-inner" style={{paddingBottom : '16px'}}>
                                    <Spin spinning={isSpinLoading}>
                                        <div className="header-popover-inner-title" style={{position:'relative'}}>
                                            <div className="inline-block hover-trigger" onMouseEnter={()=>piwikNavBar.run1()}>
                                                <img src="/cn/img/1wallet/00/arw.svg" className="arw" />{
                                                    !matchedSubBalance || this.state.oneWalletBalanceHoverSelectedId==enumWalletProductGroupId.MAIN.ID
                                                        ? MAIN_BALANCE_TEXT
                                                        : matchedSubBalance.walletProductGroupName}
                                                <div style={{height:9}}>{/*gap*/}</div>
                                                <div className="lst">
                                                    {Array.isArray(storeBalanceV2Result.balances)
                                                    && storeBalanceV2Result.balances.map((v,i)=>{
                                                        let curId = this.state.oneWalletBalanceHoverSelectedId, id = v.walletProductGroupId;
                                                        let cur = (!curId && id==enumWalletProductGroupId.MAIN.ID) || curId==id;
                                                        return <div key={i} className={cur ? 'cur' : ''} onClick={(v=>{
                                                            return ()=>{
                                                                this.setState({
                                                                    oneWalletBalanceHoverSelectedId:
                                                                        v.walletProductGroupId});
                                                                piwikNavBar.run7(v.walletProductGroupId);
                                                            }
                                                        })({...v})}><div>{
                                                            v.walletProductGroupId==enumWalletProductGroupId.MAIN.ID ? MAIN_BALANCE_TEXT : v.walletProductGroupName
                                                            }</div></div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="header-popover-inner-content">
                                            <li className="one-wallet-li-first" style={{padding:'16px 20px 0'}}>
                                                <b style={{display:'inline-block', width:'fit-content'}}>￥{formatAmount(
                                                    !matchedSubBalance
                                                    ? storeBalanceV2Result.totalBalance
                                                    : matchedSubBalance?.balance
                                                    , true)}</b>
                                                <i style={{cursor:'pointer',verticalAlign:'sub',width:20,height:20,display:'inline-block', margin:'0 0 0 4px', background:'url(/cn/img/1wallet/00/load.svg)'}}
                                                onClick={()=>{
                                                    this.props.dispatchSetBalanceV2Action();
                                                    piwikNavBar.run2();
                                                }}
                                                ></i>
                                            </li>
                                            {
                                            ((()=>{
                                                const isShowMain = !matchedSubBalance;
                                                if (isShowMain && !isToggleOn(storeBalanceV2Result)) {
                                                    return [];
                                                }
                                                let _ = storeBalanceV2Result;
                                                let a = isShowMain
                                                    ? [['可提款金额',formatAmount(_?.withdrawableBalance,true),'提款流水将在注单结算后的 15 分钟内更新',{width:205}],
                                                    ['未完成流水金额',formatAmount(_?.totalContractBalance,true),'完成流水要求即可解锁至可提款金额'],
                                                    ] : [
                                                   ['通用金额',formatAmount(matchedSubBalance?.usableAmount,true),'可用于下注任何类别游戏'],
                                                   ['优惠锁定金额',formatAmount(matchedSubBalance?.lockedBalance,true),'因申请优惠而被锁定的金额，仅可于该类别游戏中使用',{width:205}],
                                                    ]
                                                return a;
                                            })()).map((v,idx) => {
                                                const tmp = idx%2;
                                                const even = tmp===0;
                                                const odd = tmp===1;
                                                const isOn = isToggleOn(storeBalanceV2Result);
                                                const style = {};
                                                if (even && isOn) {
                                                    style.paddingRight = 41;
                                                }
                                                return (<li style={style} key={'li'+idx}>
                                                <span style={{verticalAlign:'middle'}} key={'span'+idx}>
                                                    <span className="localizedName" style={{fontSize:12,display:'inline-block'}}>{v[0]}</span>
                                                    <Popover content={v[2]} overlayStyle={v[3]||{}} trigger="hover" placement="right">
                                                        <i
                                                        onMouseEnter={(even=>{
                                                            return (()=>{
                                                                piwikNavBar[even ? 'run3' : 'run4']();
                                                            });
                                                        })(even)}
                                                        style={{verticalAlign:'sub',width:16,height:16,display:'inline-block',margin:'0 0 0 4px',background:'url(/cn/img/1wallet/00/'+(even ? 'info' : 'lock')+'.svg)'}}></i>
                                                    </Popover>
                                                </span>
                                                <span className="balance">{odd && isOn
                                                ? <i onClick={()=>{
                                                    this.props.dispatchSetBonusProgressAction(()=>{
                                                        this.LockedBalanceTrait.show()
                                                    });
                                                    piwikNavBar.run5();
                                                }} style={{float:'right',margin:'5px 0 0 5px',cursor:'pointer',width:16,height:16,display:'inline-block',background:'url(/cn/img/1wallet/00/arw2.svg) no-repeat',transform:'translate(8px, 0)'}} />
                                                : null}￥{v[1]}</span>
                                            </li>)}
                                            )}
                                        </ul>
                                          {/* centerlpayment */}
                                        {this.props.useCentralPayment && (
                                            <div className='centralPaymentWrapper'>
                                               <div onClick={() => {
                                                   Router.push('/cn/bankCard')
                                               }}>
                                                    <img src="/cn/img/icons/cpBankInfo.png" style={{width:'16px' , height:'16px' , marginRight:'12px'}} />
                                                   银行信息
                                               </div>
                                               <div onClick={() => {
                                                   Router.push('/cn/history')
                                               }} >
                                                    <img src="/cn/img/icons/cpHistory.png" style={{width:'16px' , height:'16px' , marginRight:'12px'}} />
                                                   交易记录
                                               </div>
                                               <div onClick={() => {
                                                    this.props.goUserCenter(
                                                        "betrecords"
                                                    );
                                                    Pushgtagdata(
                                                        "Account",
                                                        "Click",
                                                        "BetRecord_TopNav"
                                                    );
                                                }}
                                               >
                                                <img src="/cn/img/icons/cpBetrecode.png" style={{width:'16px' , height:'16px' , marginRight:'12px'}} />
                                                投注记录
                                            </div>
                                              
                                            </div>
                                     )}
                                    </Spin>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 财务管理，DynamicWallet內有元件使用到redux，需加上	Provider以免抓不抓不到store */}
                <Modal
                    title="钱包"
                    footer={null}
                    maskClosable={!this.state.isModalLoad}
                    keyboard={!this.state.isModalLoad}
                    width={750}
                    className="wallet-modal"
                    visible={this.state.walletVisible}
                    onCancel={this.closeWallet}
                    destroyOnClose={true}
                    closeIcon={
                        <img
                            src={"/cn/img/wallet/icon-close.svg"}
                            style={{ width: "18px", height: "18px" }}
                        />
                    }
                >
                    <Provider store={store}>
                        <Spin
                            className={this.state.isModalLoad ? "show" : "hide"}
                            size="large"
                            tip="加载中，请稍后..."
                        />
                        {this.state.modalTabKey !== "" ? (
                            <DynamicWallet
                                dialogTabKey={this.state.modalTabKey}
                                getBalance={this.getBalance}
                                balanceList={this.state.balanceList}
                                onCancel={this.closeWallet}
                                visible={this.state.walletVisible}
                                goUserCenter={this.props.goUserCenter}
                                setModalTabKey={(v, run) =>
                                    this.setState({ modalTabKey: v }, () => {
                                        typeof run === "function" && run();
                                    })
                                }
                                setLoading={(v) =>
                                    this.setState({ isModalLoad: v })
                                }
                                GetThroughoutVerification={() => {
                                    this.props.GetThroughoutVerification();
                                }}
                            />
                        ) : null}
                    </Provider>
                </Modal>

                <Mdl2025
                    isShow={this.state.precheckInfoModal}
                    isHideBtn1={false}
                    isBtnFullWidth={false}
                    isShowX={true}
                    btn1txt={'立即填写'}
                    btn2txt={'返回'}
                    onClick1={()=>{
                        this.setState({ precheckInfoModal: false });
                        sessionStorage.setItem("unFinishInfo", "true");
                        this.props.goUserCenter(
                            "userinfo"
                        );
                    }}
                    onClick2={()=>{
                        this.setState({ precheckInfoModal: false });
                    }}
                    onClickX={'SAME_AS_ONCLICK2'}
                    hd="完善基本个人资料"
                    bd='尊敬的会员, 在您存款前请完善基本个人信息, 以便日后用以核对账户身份及保护您的账户权益'
                />

                <Mdl2025
                    isShow={this.state.precheckPhoneModal}
                    isHideBtn1={false}
                    isBtnFullWidth={false}
                    isShowX={true}
                    btn1txt={'立即验证'}
                    btn2txt={'返回'}
                    onClick1={()=>{
                        this.setState({ precheckPhoneModal: false });
                        sessionStorage.setItem("unFinishInfo", "true");
                        this.props.goUserCenter(
                            "userinfo"
                        );
                    }}
                    onClick2={()=>{
                        this.setState({ precheckPhoneModal: false });
                    }}
                    onClickX={'SAME_AS_ONCLICK2'}
                    hd="温馨提示"
                    bd='请验证您的电话号码'
                />
                {this.state.isLoadOtpModal == true ? (
                    <DynamicOtpPopUp
                        otpVisible={this.state.otpVisible} // 彈窗顯示
                        otpModal={(v) => {
                            this.otpModal(v);
                            getMemberInfo((res) => {
                                this.setGlobalMemberInfo(res);
                            }, true);
                        }} // 彈窗控制
                        otpParam={`login-otp`} // 類別
                        memberInfo={this.state.memberInfo} // 會員信息
                        kindOfVerification={this.state.kindOfVerification}
                        GetThroughoutVerification={() => {
                            this.props.GetThroughoutVerification();
                        }}
                    />
                ) : null}
                {this.LockedBalanceTrait.renderModalLockedBalance(storeBalanceV2Result, storeBonusProgressResult)}
                {isToggleOn(storeBalanceV2Result) &&
                <Newbie imgsrc={"/cn/img/newbie/" + IMG_BALANCE_DETAIL_NEWBIE + '.png'}
                    imgstyle={{width:560,top:180,left:'50%',transform:'translateX(-40px)'}}
                    btnstyle={{top:457,marginLeft:290}}
                    isHide={this.state.isHideBalanceDtlNewbie}
                    />
                }
                <ResetPwd ref="ResetPwdModal" />
            </React.Fragment>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        storeBalance: state.balance,
        storeBonus: state.bonus,
        topTabIndex: state.promotion.topTabIndex,
        smarticoVisible: state.game.smarticoVisible,
		isFollowInLogin: state.userCenter.isFollowInLogin,
        useCentralPayment: state.centralPayment.useCentralPayment
	};
};

const mapDispatchToProps = function (dispatch) {
    return {
        dispatch,
        dispatchSetBalanceUIIsLoadingAction: (b) => {
            dispatch(balanceActions.setUIIsLoading(b));
        },
        dispatchSetBalanceV2Action: (walletProductGroupId=DEFAULT_PARAMS.walletProductGroupId) => {
            dispatch(setBalanceV2Action(walletProductGroupId));
        },
        dispatchSetBalanceWalletGroupAction: () => {
            dispatch(setBalanceWalletGroupAction());
        },
        dispatchSetBonusProgressAction: (call) => {
            dispatch(setBonusProgressAction(call));
        },
        changeTab: (i) => {
            dispatch(promotionActions.changeTab(i));
        },
        resetPromotionData: () => {
            dispatch(promotionActions.resetData());
        },
        resetMemberData: () => {
            dispatch(userCenterActions.resetData());
        },
        setIsFollowInLogin: (isFollowInLogin = false) => {
            dispatch(
                userCenterActions.setIsFollowInLogin(isFollowInLogin)
            );
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HasLogged);
